import React from 'react';

const PLAN_STYLES = {
  LIST: 'border-kelate-line text-kelate-soft',
  STORE: 'border-kelate-wood text-kelate-wood',
  BOOST: 'border-kelate-sage text-[#5F7050]',
  BRAND: 'border-kelate-darkwood text-kelate-darkwood',
};

export function PlanBadge({ plan }) {
  return (
    <span data-testid={`plan-badge-${plan.toLowerCase()}`} className={`inline-flex items-center rounded-sm border bg-transparent px-2 py-0.5 text-[11px] font-semibold tracking-widest ${PLAN_STYLES[plan] || ''}`}>
      {plan}
    </span>
  );
}
